// @ts-nocheck
export class AxiosError extends Error {
  constructor(message, status, data) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

export default AxiosError;
